import { render, staticRenderFns } from "./selectSegmentCustom.vue?vue&type=template&id=e86c5d9c&"
import script from "./selectSegmentCustom.vue?vue&type=script&lang=js&"
export * from "./selectSegmentCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports